export const phoneFormat = {
    methods: {
        // 핸드폰번호 11자리 들어오면 000-0000-0000 처럼 변환
        phoneFormat(phoneNum=''){
            return phoneNum.replace(/[^0-9]/g, "") //숫자만
                .replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
        }
    },
}